import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Background, Hr, Titulo, Input, Row, Table, ButtonAdd, Botoes } from "./style";
import api from "../../../services/api";
import { Swal } from "../../../services/SwalTemplates";
import Envio from "../../../components/Modal/Rh/Email/Envio";
import Pagination from "../../../components/Pagination";
import { IoTrashOutline, IoQrCode } from "react-icons/io5";
import { MdEdit } from "react-icons/md";
import ModalQrCodeViewer from "../../../components/Modal/Rh/ControleCestas/Viewer";
import ModalEdit from "../../../components/Modal/Rh/ControleCestas/Edit";
import { formatDatesHoras } from "../../../utils/formatDates";
import ImportExcel from "../../../components/Modal/Rh/ControleCestas/ImportExcel";

export default function Retiradas() {
  const anoAtual = new Date().getFullYear();
  const [filtro, setFiltro] = useState("");
  const [retiradas, setRetiradas] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [ano, setAno] = useState(anoAtual);
  const [openModal, setOpenModal] = useState(false);
  const [openModalExcel, setOpenModalExcel] = useState(false);
  const [openModalEnvio, setOpenModalEnvio] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [selectedRetirada, setSelectedRetirada] = useState(null);
  const [anos, setAnos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    carregarAnos();
    carregarRetiradas();
  }, [ano]);

  const carregarAnos = () => {
    api
      .get(`/rh/controle-cestas/anos-distintos`)
      .then((response) => {
        console.log("anos", response.data.items);
        setAnos(response.data.items || []);
      })
      .catch((e) => {
        Swal.fire({
          title: "Atenção!",
          text: `${e.response?.data?.error || "Não foi possível consultar os anos disponíveis!"}`,
          icon: "error",
        });
      });
  };

  const carregarRetiradas = () => {
    setLoading(true);
    api
      .get(`/rh/controle-cestas/listar-qrcodes/${ano}`)
      .then((response) => {
        setRetiradas(response.data.items || []);
      })
      .catch((e) => {
        Swal.fire({
          title: "Atenção!",
          text: `${e.response?.data?.error || "Não foi possível consultar as retiradas!"}`,
          icon: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const DeletarRetirada = (matricula) => {
    Swal.fire({
      title: "Atenção!",
      text: "Tem certeza que deseja remover este registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`/rh/controle-cestas/deletar?matricula=${matricula}`)
          .then(() => {
            Swal.fire({
              title: "Sucesso!",
              text: "Removido com sucesso!",
              icon: "success",
            });
            carregarAnos();
            carregarRetiradas();
          })
          .catch((e) => {
            Swal.fire({
              title: "Atenção!",
              text: `${e.response?.data?.error || "Não foi possível remover!"}`,
              icon: "error",
            });
          });
      }
    });
  };

  useEffect(() => {
    setTotalPages(Math.ceil(retiradasFiltradas.length / 15));
  }, [retiradas, filtro]);

  const normalize = (str) =>
    str
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase() || "";

  const filtroNormalizado = normalize(filtro);

  const retiradasFiltradas = retiradas.filter((r) => {
    if (!filtro) return true;

    const nome = normalize(r.nome);
    const matricula = r.matricula?.toString() || "";

    return nome.includes(filtroNormalizado) || matricula.includes(filtroNormalizado);
  });

  return (
    <Background>
      <Container>
        <Titulo>Retiradas - Ano {ano}</Titulo>
        <Hr />
        <Row>
          <Botoes>
            <Input>
              <input
                type="text"
                placeholder="Pesquisar por matrícula ou nome..."
                value={filtro}
                onChange={(e) => {
                  setFiltro(e.target.value.toUpperCase());
                  setPage(1);
                }}
              />
            </Input>
            <Input>
              <select
                value={ano}
                onChange={(e) => {
                  setAno(Number(e.target.value));
                  setPage(1);
                }}
              >
                {anos.map((year) => (
                  <option key={year} value={year.ano}>
                    {year.ano}
                  </option>
                ))}
              </select>
            </Input>
          </Botoes>
          <Botoes>
            <ButtonAdd onClick={() => setOpenModalEnvio(true)}>Enviar email</ButtonAdd>
            <ButtonAdd
              onClick={() => {
                setOpenModalExcel(true);
              }}
            >
              Carregar excel
            </ButtonAdd>
            <Link to="/retiradascadastro">
              <ButtonAdd>Registrar Retirada</ButtonAdd>
            </Link>
          </Botoes>
        </Row>

        <Table>
          <table>
            <thead>
              <tr>
                <th>Matrícula</th>
                <th>Colaborador</th>
                <th>Email</th>
                <th>Cesta</th>
                <th>Brinquedo</th>
                <th>Rt. Cesta</th>
                <th>Rt. Brinquedo</th>
                <th colSpan={3}></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    Carregando...
                  </td>
                </tr>
              ) : retiradasFiltradas.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    Nenhum registro encontrado
                  </td>
                </tr>
              ) : (
                retiradasFiltradas.slice((page - 1) * 15, page * 15).map((d, i) => (
                  <tr key={i}>
                    <td data-title="Matrícula">{d.matricula}</td>
                    <td data-title="Colaborador" className="td-left">
                      {d.nome?.toUpperCase() || "-"}
                    </td>
                    <td data-title="Email" className="td-left">
                      {d.email || "-"}
                    </td>
                    <td data-title="Cesta">{d.cesta_natal ? "Sim" : "Não"}</td>
                    <td data-title="Brinquedo">{d.qr_code_brinquedo_text != null ? "Sim" : "Não"}</td>
                    <td data-title="Retirada Cesta">{formatDatesHoras(d.data_retirada_cesta) || "-"}</td>
                    <td data-title="Retirada Brinquedo">{formatDatesHoras(d.data_retirada_brinquedo) || "-"}</td>
                    <td>
                      <IoQrCode
                        style={{ width: "80%", height: "80%", cursor: "pointer" }}
                        onClick={() => {
                          setOpenModal(true);
                          setSelectedRetirada(d);
                        }}
                      />
                    </td>
                    <td>
                      <MdEdit
                        title="Editar"
                        style={{ fontSize: "25px", cursor: "pointer" }}
                        onClick={() => {
                          setSelectedRetirada(d);
                          setOpenModalEdit(true);
                        }}
                      />
                    </td>
                    <td>
                      <IoTrashOutline
                        title="Excluir"
                        style={{ fontSize: "25px", cursor: "pointer" }}
                        onClick={async () => {
                          DeletarRetirada(d.matricula);
                        }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Table>
        <ModalQrCodeViewer showModal={openModal} setShowModal={setOpenModal} qrData={selectedRetirada} />
        <ModalEdit showModal={openModalEdit} setShowModal={setOpenModalEdit} data={selectedRetirada} recarregaTabela={carregarRetiradas} />
        <Envio showModal={openModalEnvio} setShowModal={setOpenModalEnvio} />
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
        <ImportExcel showModal={openModalExcel} setShowModal={setOpenModalExcel} recarregaTabela={carregarRetiradas} />
      </Container>
    </Background>
  );
}
